<template>
  <div class="container">
    <div class="left">
      <!-- left -->
    </div>

    <section class="section">
      <form>
        <input
          type="text"
          :value="url"
          :ref="'url'"
          placeholder="enter twitter url here"
        />
        <br />
        <button @click.prevent="post">translate</button>
      </form>
    </section>
    <section class="section1">
      <span class="floatRight" @click="toggleAccordion('whatIs')">
        <div
          v-if="openComp[0].visible === true && innerWidth <= 480"
          class="openSection"
          style="align-items: center; text-align: center;"
        >
          V
        </div>
        <div v-else-if="innerWidth <= 480" class="closedSection">
          >
        </div>
        <div v-else></div>
      </span>
      <h3 @click="toggleAccordion('whatIs')">What is Slow Band?</h3>

      <article class="article-content" :ref="'whatIs'">
        <p>
          Slow Band provides a contrasting experience equivalent to a poor
          internet connection.
        </p> 
        <p>
          Bandwidth intensive elements are simply replaced with textual elements
          of what was supposed to be displayed.
        </p>
        <p>
          Currently, this app can only work with Tweets from Twitter.
        </p>
        <p>
          Next gen versions will include the ability to contrast other social
          media and websites
        </p>
      </article>
    </section>
    <div class="right">
      <!-- right -->
    </div>
    <section class="section2">
      <span class="floatRight" @click="toggleAccordion('howWorks')">
        <div
          v-if="openComp[1].visible === true && innerWidth <= 480"
          class="openSection"
        >
          V
        </div>
        <div v-else-if="innerWidth <= 480" class="closedSection">
          >
        </div>
        <div v-else></div>
      </span>
      <h3 @click="toggleAccordion('howWorks')">How Slow Band works</h3>
      <article class="article-content" :ref="'howWorks'">
        <p>
          In the text box below, enter the url of tweet that you'd like to
          contrast.
        </p>
        <p>
          The translate button will take the tweet and return only text for you
          to preview on the next page
        </p>
        <p>
          From there, the app will ask you to save the contrast and then offer a
          tweet button.
        </p>
        <p>
          The tweet button will take you to twitter and let you tweet from
          there.
        </p>
      </article>
    </section>
    <section class="section3">
      <span class="floatRight" @click="toggleAccordion('recent')">
        <div
          v-if="openComp[2].visible === true && innerWidth <= 480"
          class="openSection"
        >
          V
        </div>
        <div v-else-if="innerWidth <= 480" class="closedSection">
          >
        </div>
        <div v-else></div>
      </span>
      <h3 @click="toggleAccordion('recent')">Recent SlowBand</h3>
      <article class="article-content" :ref="'recent'"></article>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      concept1: "concept one, two, three",
      url: "",
      status: "",
      openComponent: [
        { name: "whatIs", visible: true },
        { name: "howWorks", visible: false },
        { name: "recent", visible: false }
      ],
      openBox: 0,
      client: "mobile"
    };
  },
  mounted() {
    this.loadAccordion;
  },
  computed: {
    openComp() {
      return this.openComponent;
    },
    innerWidth() {
      return window.innerWidth;
    },
    loadAccordion() {
      let allSegments = Object.keys(this.$refs);
      let self = this;
      let textSegments = allSegments.filter(ref => {
        if (ref !== "url") {
          return ref;
        }
      });
      if (window.innerWidth <= 480) {
        textSegments.forEach((element, index) => {
          if (index === self.openBox) {
            self.$refs[element].style.display = "";
            self.openComponent[index].visible = true;
          } else {
            self.$refs[element].style.display = "none";
            self.openComponent[index].visible = false;
          }
        });
      } else {
        textSegments.forEach((element, index) => {
          self.$refs[element].style.display = "";
          self.openComponent[index].visible = true;
        });
      }
      return true;
    }
  },
  methods: {
    ...mapActions(["saveApiData"]),
    async post() {
      const formdata = new FormData();
      formdata.append("url", this.$refs.url.value);
      let called_url = this.$refs.url.value;
      let split_url = this.$refs.url.value.split("/");
      let endList = split_url.length;
      let tweet_id = split_url[endList - 1];
      axios
        .post("https://slow-band-v1.herokuapp.com/api/translate", formdata)
        .then(data => {
          let dataPkg = {
            data,
            called_url,
            tweet_id
          };
          this.saveApiData(dataPkg);
          this.$router.push("Translate");
        });
    },
    toggleAccordion(refr) {
      let self = this;
      this.openComponent.forEach(element => {
        if (element.name === refr) {
          if (element.visible) {
            self.$refs[refr].style.display = "none";
            element.visible = false;
          } else {
            self.$refs[refr].style.display = "";
            element.visible = true;
          }
        } else {
          self.$refs[element.name].style.display = "none";
          element.visible = false;
        }
      });
    }
  }
};
</script>
<style lang="sass">
$font-stack:    Arial, sans-serif
$primary-color: #333
</style>
